import { apiRequest } from "@/features/api/apiClient";
import type { Project, ProjectStatus } from "@/features/projects/projectTypes";

type ProjectResponse = {
  project: Project;
};

type ProjectsResponse = {
  projects: Project[];
};

export function listProjects(token: string | null): Promise<ProjectsResponse> {
  return apiRequest<ProjectsResponse>("/api/projects", { token });
}

export function getProject(
  token: string | null,
  projectId: string,
): Promise<ProjectResponse> {
  return apiRequest<ProjectResponse>(`/api/projects/${projectId}`, { token });
}

export function createProject(
  token: string | null,
  name: string,
): Promise<ProjectResponse> {
  return apiRequest<ProjectResponse>("/api/projects", {
    method: "POST",
    token,
    body: { name },
  });
}

export function updateProject(
  token: string | null,
  projectId: string,
  updates: { name?: string; status?: ProjectStatus },
): Promise<ProjectResponse> {
  return apiRequest<ProjectResponse>(`/api/projects/${projectId}`, {
    method: "PATCH",
    token,
    body: updates,
  });
}

export function deleteProject(
  token: string | null,
  projectId: string,
): Promise<void> {
  return apiRequest<void>(`/api/projects/${projectId}`, {
    method: "DELETE",
    token,
  });
}
